import React, { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'
import { store } from '../../store'
import { AuthSignup, AuthSignin } from '../../hooks/firebaseAuth'

function FormSign(){
    const firebaseSignup = AuthSignup()
    const firebaseSignin = AuthSignin()
    const [secret, setSecret] = useState('password');
    const [eye, setEye] = useState('fas fa-eye fa-2x mt-1');
    const [login, setLogin] = useState(true);
    const [email, setEmail] = useState(undefined);
    const [password, setPassword] = useState(undefined);
    const history = useHistory()
    const { dispatch } = useContext(store)

    const secretChange = () => {
        if (secret === 'password') {
            setSecret('text')
            setEye('fas fa-eye-slash fa-2x mt-1')
        } else {
            setSecret('password')
            setEye('fas fa-eye fa-2x mt-1')
        }
    }

    function loginChange(){
        login ? setLogin(false) : setLogin(true)
    }

    const handleEmailValue = e => {
        setEmail(e.target.value)
    }

    const handlePassValue = e => {
        setPassword(e.target.value)
    }

    function launchSwall(message){
        if (message === 'There is no user record corresponding to this identifier. The user may have been deleted.') {
            message = 'email or password wrong!'
        }
        Swal.fire({
            toast: true,
            position: "top",
            title: 'ALERT!',
            text: message,
            timer: 2500,
            imageAlt: 'Custom image',
            showConfirmButton: false,
            showCancelButton: false,
            confirmButtonText: 'نعم',
            cancelButtonText: 'لا',
        })
    }

    function validateEmail(email) {
        // eslint-disable-next-line
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function checkLogin(e,action){
        e.preventDefault()
        if(email && password){
            if (validateEmail(email)) {
                if (action === 'login') {
                    firebaseAuthSignin(email,password)
                } else {
                    firebaseAuthSignup(email,password)
                }
            } else {
                launchSwall("email is unformat!")
            }
        }
        if (!email && !password) {
            launchSwall("email & password is required!")
        } else if (!password) {
            launchSwall("password is required!")
        } else if (!email){
            launchSwall("email is required!")
        }
    }

    function firebaseAuthSignin(email,password){
        firebaseSignin(email,password)
                .then(({user})=>{
                    dispatch({
                        type: 'USER_SIGNIN',
                        email: user.email
                    })
                    localStorage.setItem('account', user.email)
                    history.replace('/manage')
                })
                .catch(error=>{ launchSwall(error.message) })
    }

    function firebaseAuthSignup(email,password){
        firebaseSignup(email, password)
            .then(_=>{
                localStorage.setItem('account', email)
                localStorage.setItem('test', false)
                history.replace('/manage')
            })
            .catch(error=>{ launchSwall(error.message) })
    }

    return (
        <div className="form-group mt-3">
            <div className="form-group text-center" >
                <div className="row">
                    <small id="helpId" className="form-text text-muted text-left ml-4 mt-auto">Username</small>
                    {
                        login ? 
                        <small id="helpId" className="form-text text-muted ml-auto mr-4" style={{ fontSize: '20px' }}>SignIn</small>
                        :
                        <small id="helpId" className="form-text text-muted ml-auto mr-4" style={{ fontSize: '20px' }}>SignUp</small>
                    }
                </div>
                <input type="email" data-testid="form-email" onChange={e => handleEmailValue(e) } className="text-center form-control" name="" id="" aria-describedby="helpId" placeholder="Username"/>
                <div className="d-flex flex-row mt-1">
                    <input type={ secret } data-testid="form-password" onChange={ e => handlePassValue(e) } className="text-center form-control mr-2" name="password" id="" aria-describedby="helpId" placeholder="Password"/>
                    <i className={ eye } onClick={ secretChange } style={{ cursor: "pointer" }}></i>
                </div>
                {
                    login ? 
                    <>
                        <button type="button" onClick={ e => checkLogin(e,'login') } data-testid="signin-test" className="btn btn-primary mt-3 px-5">SignIn</button>
                        <button type="button" onClick={ loginChange } data-testid="signup-test" className="btn btn-light btn-sm mt-3 ml-2">SignUp</button>
                    </>
                    :
                    <>
                        <button type="button" onClick={ e => checkLogin(e,'register') } className="btn btn-primary mt-3 px-5">SignUp</button>
                        <button type="button" onClick={ loginChange } className="btn btn-light btn-sm mt-3 ml-2">SignIn</button>
                    </>
                }
            </div>
        </div>
    );
}

export default FormSign